/**
 * Returns either `window` or `global` object depending on
 * wether the code is running on the client or in Node.
 */

'use strict'
module.exports = (typeof self === 'object' && self.self === self && self) ||
  (typeof global === 'object' && global.global === global && global) ||
  this
